export const appsettingConstants = {
    LOGOUT: 'APPSETTINGS_LOGOUT',

    //get
    GET_APPSETTING_LIST_REQUEST: "GET_APPSETTING_LIST_REQUEST",
    GET_APPSETTING_LIST_SUCCESS: "GET_APPSETTING_LIST_SUCCESS",
    GET_APPSETTING_LIST_FAILURE: "GET_APPSETTING_LIST_FAILURE", 

    GET_FEE_SETTING_LIST_REQUEST: "GET_FEE_SETTING_LIST_REQUEST",
    GET_FEE_SETTING_LIST_SUCCESS: "GET_FEE_SETTING_LIST_SUCCESS",
    GET_FEE_SETTING_LIST_FAILURE: "GET_FEE_SETTING_LIST_FAILURE", 

    //update status
    UPDATE_APPSETTING_STATUS_REQUEST: "GET_APPSETTING_STATUS_REQUEST",
    UPDATE_APPSETTING_STATUS_SUCCESS: "GET_APPSETTING_STATUS_SUCCESS",
    UPDATE_APPSETTING_STATUS_FAILURE: "GET_APPSETTING_STATUS_FAILURE",
};
